var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "slider-banner" }, [
    _vm.bannerList.length > 0 &&
    Object.keys(_vm.banners2).includes(
      _vm.mapLangFallback(_vm.language) || _vm.language
    )
      ? _c(
          "div",
          { attrs: { "data-lang": _vm.language } },
          [
            _c(
              "VueSlickCarousel",
              _vm._b(
                { key: _vm.refreshNum },
                "VueSlickCarousel",
                _vm.setting,
                false
              ),
              _vm._l(
                _vm.banners2[_vm.mapLangFallback(_vm.language) || _vm.language],
                function (item) {
                  return _c("div", { key: item }, [
                    _c("img", {
                      attrs: { src: `/icon/banner/${item}`, alt: "" },
                    }),
                  ])
                }
              ),
              0
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }